/**
 * 此为model基类,所有业务层model都要继承此类
 */
import axios from 'axios'
import replaceVars from 'utils/replace-vars'
import date from 'utils/date'
import constants from 'config/constants'
import fileDownload from 'js-file-download'
import {showLoading, hideLoading} from 'components/loading'

/**
 * 默认查询query参数配置
 */
const DEFAULT_PARAMS = {
  // 开发模式下，没有 cordova 对象，默认给值 'browser'
  CLIENT: 'web',
  TIMESTAMP: date(new Date().getTime(), 'yyyy-MM-dd h:m:s')
}
const MSG_CODE = {
  OK: 200,
  UNKNOWN_USER: 1001,
  USER_NOT_LOGIN: 1002,
  USER_EXIST: 1003,
  UNKNOWN_PASSWORD: 1004,
  DATA_EXIST: 3001,
}
const signBase = {
  client: DEFAULT_PARAMS.CLIENT,
  timestamp: DEFAULT_PARAMS.TIMESTAMP
}

/**
 * 数据模型，用来封装业务数据请求
 */
export default class Base {
  /**
   * 解析 params
   * @param {Object} _signParams
   * @returns {String}
   */
  _makeURLParams (_signParams) {
    const _params = Object.keys(_signParams)
    let _urlParams = '?'
    for (let i = 0; i < _params.length; i++) {
      _urlParams += `${_params[i]}=${_signParams[_params[i]]}`
      if (i < _params.length - 1) _urlParams += '&'
    }
    return _urlParams
  }

  /**
   * 组织接口参数
   * @param {Object} options
   * @returns {Object}
   */
  _handleHttpOptions (options) {
    let { vars = {}, url, params = {}, } = options
    if (!url) {
      throw new Error('please set param  "url" ! ')
    }

    // 替换url中的变量
    // === url.indexOf()<-1
    if (~url.indexOf('${')) {
      url = replaceVars(url, vars)
    }

    Object.assign(params, signBase)
    // 参数拼接到url
    url += this._makeURLParams(params)
    // 拼接接口服务器的域
    options.url = constants.basic.domain + url
    return options
  }

  /**
   * 处理返回结果
   * @param {Object} options
   * @returns {Promise}
   */
  _handleHttpResult (_promise) {
    return _promise.then(res => {
      // console.log(res)
      /* eslint-disable no-new */
      return new Promise((resolve, reject) => {
      /* eslint-enable */
        if (res.data.code) {
          switch (res.data.code) {
            case MSG_CODE.OK: resolve(res.data.data)
              break
            default: responseErr(res.data)
          }
        } else {
          responseErr(res.data)
        }

        function responseErr (myErr) {
          if (myErr.code) {
            let err = new Error(myErr.msg)
            err.mycode = myErr.code
            err.data = myErr.data
            reject(err)
          } else {
            let err = new Error(myErr)
            reject(err)
          }
        }
      })
    }).catch(err => {
      if (err.response) {
        // console.log('Reponse Error')
        // console.log(err.response)
        switch (err.response.status) {
          case 401:
            if (global.location.hash !== '#/login') {
              global.location.replace('#/login')
            }
            throw new Error('用户未登录')
          default:
        }
      } else if (err.request) {
        console.log('Request Error')
        console.log(err.request)
      } else if (err.mycode) {
        switch (err.mycode) {
          case MSG_CODE.USER_EXIST:
            throw new Error(err.data + '已存在')
          case MSG_CODE.DATA_EXIST:
            throw new Error(err.data + '已存在')
          default:
            throw err
        }
      } else {
        console.log('Unknow Error', err.message)
      }
      // console.log(err.config)
      throw err
    })
  }

  /**
   * @param {Object} options
   * @returns {Promise}
   */
  httpGet (options) {
    let {url, data, params = {}} = options
    if (!url) {
      throw new Error('please set param  "url" ! ')
    }
    Object.assign(params, data, signBase)
    url += this._makeURLParams(params)
    // 拼接接口服务器的域
    options.url = constants.basic.domain + url
    return this._handleHttpResult(axios.get(options.url))
  }
  /**
   * @param {Object} options
   * @returns {Promise}
   */
  httpPost (options) {
    options = this._handleHttpOptions(options)
    return this._handleHttpResult(axios.post(options.url, options.data))
  }

  httpDownload (options) {
    showLoading()
    options.url = constants.basic.domain + options.url
    axios({
      url: options.url,
      method: 'post',
      data: options.data,
      responseType: 'blob'
    }).then(function (response) {
      console.log(response)
      let disposition = response.headers['content-disposition']
      console.log(disposition)
      let filename = decodeURI(disposition.match(/filename="(.*)"/)[1])
      fileDownload(response.data, filename)
      hideLoading()
    }).catch((err) => {
      // 像这种未知错误也要发送到服务端才好
      console.log(err.message)
      hideLoading()
    })
  }
}



// WEBPACK FOOTER //
// ./src/models/base.js